import { IPhongHocActionTypes } from "../../action-types/category/IPhongHocActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongHocReducer } from "../../reducer-model/category/IPhongHocReducer";
const initState: IPhongHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  phongHocs: [],
  coSoIdFilter: 0,
  selectedIds: [],
  isShowPhongHocTrongKyModal: false,
};

export const phongHocReducer = (
  state: IPhongHocReducer = initState,
  action: IPhongHocActionTypes
): IPhongHocReducer => {
  switch (action.type) {
    case "PHONG_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "PHONG_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        phongHocs: action.payload,
      };
    case "PHONG_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "PHONG_HOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        phongHocEditing: action.payload,
      };
    case "PHONG_HOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "PHONG_HOC_SHOW_SUBJECT_MODAL":
      return {
        ...state,
        isShowSubjectModal: true,
        phongHocSubject: action.payload,
      };
    case "PHONG_HOC_CLOSE_SUBJECT_MODAL":
      return {
        ...state,
        isShowSubjectModal: false,
      };
    case "PHONG_HOC_SHOW_BUSY_MODAL":
      return {
        ...state,
        isShowBusyModal: true,
        phongHocBusy: action.payload,
      };
    case "PHONG_HOC_CLOSE_BUSY_MODAL":
      return {
        ...state,
        isShowBusyModal: false,
      };
    case "PHONG_HOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "PHONG_HOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "PHONG_HOC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "PHONG_HOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "PHONG_HOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        selectedIds: [],
      };
    case "PHONG_HOC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "PHONG_HOC_CHANGE_COSO_FILTER":
      return {
        ...state,
        coSoIdFilter: action.payload
      };
    case "PHONG_HOC_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    case "PHONG_HOC_SHOW_PHONG_HOC_TRONG_KY_MODAL":
      return {
        ...state,
        isShowPhongHocTrongKyModal: true,
      };
    case "PHONG_HOC_CLOSE_PHONG_HOC_TRONG_KY_MODAL":
      return {
        ...state,
        isShowPhongHocTrongKyModal: false,
      };
    default:
      return state;
  }
};
